import { useSelector } from 'react-redux';
import i18n from 'i18next';

import { useGetSpotBidExpirationTimeOptions } from '@/views/screens/Shipment';

import FormSelectBox from '../Inputs/FormSelectBox';

const SpotBidExpireTimeSelector = ({
  placeholder = i18n.t('translation:default.fields.hours.placeholder'),
  label = i18n.t('translation:default.fields.hours.label'),
  rules = [],
  name,
  editMode,
  margin,
  onChange,
}) => {
  const { selectedCompany } = useSelector((state) => state.auth);
  const { data: options, isLoading } = useGetSpotBidExpirationTimeOptions({ CustomerKey: selectedCompany?.companyId });

  return (
    <FormSelectBox
      loading={isLoading}
      options={options}
      placeholder={placeholder}
      label={label}
      rules={rules}
      name={name}
      editMode={editMode}
      margin={margin}
      onChange={onChange}
    />
  );
};

export default SpotBidExpireTimeSelector;
